var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4291 6.41777C19.32 6.28087 19.1166 6.27318 18.9929 6.39705L16.2896 9.10379C16.1844 9.20913 16.1731 9.37519 16.2563 9.49869C16.8019 10.3096 17.1294 11.2759 17.1294 12.3232C17.1294 13.3745 16.8009 14.3438 16.2541 15.1568C16.1711 15.2803 16.1823 15.4463 16.2875 15.5516L18.988 18.2556C19.1117 18.3794 19.315 18.3718 19.4241 18.235C20.7207 16.6109 21.5004 14.5579 21.5004 12.3232C21.5004 10.0917 20.7227 8.04078 19.4291 6.41777Z",
    fill: "#6E63B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71676 15.5536C7.822 15.4483 7.8333 15.2823 7.7502 15.1587C7.20331 14.3458 6.874 13.3764 6.874 12.3243C6.874 11.2769 7.20232 10.3106 7.74808 9.49984C7.83123 9.3763 7.81996 9.2102 7.7147 9.10487L5.00855 6.39698C4.88482 6.27317 4.68146 6.28089 4.57236 6.41776C3.27864 8.04078 2.5 10.0917 2.5 12.3243C2.5 14.5599 3.28066 16.6131 4.57831 18.2373C4.68749 18.3739 4.89066 18.3815 5.01429 18.2578L7.71676 15.5536Z",
    fill: "#6E63B8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77667 8.04497C8.88183 8.15023 9.04775 8.16172 9.17133 8.07885C9.98409 7.53382 10.9525 7.20622 12.0028 7.20622C13.053 7.20622 14.0214 7.53381 14.8341 8.07882C14.9577 8.1617 15.1237 8.1502 15.2288 8.04491L17.9337 5.33659C18.0572 5.21289 18.0495 5.00983 17.9129 4.90074C16.2887 3.604 14.2355 2.82422 12.0008 2.82422C9.76702 2.82422 7.71398 3.60394 6.0907 4.89972C5.95405 5.0088 5.94633 5.2119 6.06991 5.3356L8.77667 8.04497Z",
    fill: "#6E63B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2268 16.6143C15.1215 16.5089 14.9554 16.4975 14.8318 16.5806C14.0198 17.1263 13.0516 17.4538 12.0015 17.4538C10.9522 17.4538 9.98408 17.1262 9.17215 16.5806C9.04855 16.4975 8.88244 16.5089 8.77717 16.6142L6.07482 19.3183C5.95117 19.442 5.95892 19.6452 6.09568 19.7543C7.71786 21.0479 9.76879 21.8248 11.9995 21.8248C14.2321 21.8248 16.2831 21.047 17.9062 19.7532C18.043 19.6442 18.0508 19.441 17.9271 19.3172L15.2268 16.6143Z",
    fill: "#6E63B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTicketIcon);
export default __webpack_public_path__ + "static/media/support_ticket_icon.602e4575571cddc66b3e43c6fbcb178d.svg";
export { ForwardRef as ReactComponent };